import { render, staticRenderFns } from "./RelayBoxLocations.vue?vue&type=template&id=b4a5d8e6&"
import script from "./RelayBoxLocations.vue?vue&type=script&lang=ts&"
export * from "./RelayBoxLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports